<template>
    <div>
        <section class="form-section">
            <div class="form-section-heading">
                {{ trans('bookings.headline.license_information') }}
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <label class="label" for="debit_client_id">
                        {{ trans('bookings.label.debit_client_id') }}
                    </label>
                    <select
                        name="debit_client_id"
                        :class="[
                            'form-select',
                            { 'form-select--error': errors('debit_client_id') },
                        ]"
                        v-model="fields.debitClientId"
                        id="debit_client_id"
                    >
                        <option disabled value="">{{
                            trans('clients.label.select')
                        }}</option>
                        <option
                            v-for="debitClient in filteredDebitClients"
                            :key="debitClient.id"
                            :value="debitClient.id"
                            :disabled="debitClient.license_amount == 0"
                        >
                            {{ debitClient.prefixed_name }}
                            {{
                                debitClient.license_plan == 'license_plan_alpha'
                                    ? '(' +
                                      trans('licenses.label.amount') +
                                      ': ' +
                                      debitClient.license_amount +
                                      ')'
                                    : ''
                            }}
                        </option>
                    </select>

                    <span
                        class="invalid-feedback"
                        v-if="errors('debit_client_id')"
                    >
                        <strong>{{ errors('debit_client_id') }}</strong>
                    </span>
                </div>

                <div class="form-row__col form-row__col--one-half">
                    <form-input
                        name="license_amount"
                        :required="true"
                        type="number"
                        min="1"
                        step="1"
                        :max="getLicenseAmountOfSelectedClient"
                        v-model="fields.licenseAmount"
                    >
                        {{ trans('bookings.label.license_amount') }}
                    </form-input>
                </div>
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <form-date
                        name="start_date"
                        :initial-date="new Date(Date.now())"
                        v-model="fields.startDate"
                        :min-date="minDate"
                        :required="true"
                    >
                        {{ trans('bookings.label.start_date') }}
                    </form-date>
                </div>
            </div>
        </section>

        <section class="form-section">
            <div class="form-section-heading">
                {{ trans('bookings.headline.interval_information') }}
            </div>

            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <label class="label" for="repeat">
                        {{ trans('bookings.label.repeat') }}
                    </label>
                    <select
                        name="repeat"
                        v-model="fields.repeat"
                        id="repeat"
                        class="form-select"
                    >
                        <option disabled value="">{{
                            trans('clients.label.select')
                        }}</option>
                        <option value="1">{{ trans('form.yes') }}</option>
                        <option value="0">{{ trans('form.no') }}</option>
                    </select>
                </div>

                <div
                    class="form-row__col form-row__col--one-half"
                    v-if="fields.repeat == '1'"
                >
                    <form-input
                        name="repeat_period"
                        :required="true"
                        type="number"
                        min="1"
                        step="1"
                        v-model="fields.repeatPeriod"
                    >
                        {{ trans('bookings.label.repeat_period') }}
                    </form-input>
                </div>
            </div>
        </section>

        <div class="page-control">
            <div class="page-control__element">
                <button type="submit" class="btn btn--big btn--primary">
                    {{ trans('licenses.label.transfer_licenses') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        client: {
            type: Object,
            default: () => {
                return {};
            },
        },
        debitClients: {
            type: Array,
        },
    },

    data() {
        return {
            fields: {
                debitClientId: this.old('debit_client_id', ''),
                licenseAmount: this.old('license_amount'),
                repeat: this.old('repeat', 0),
                repeatPeriod: this.old('repeat_period', 12),
                startDate: this.old('start_date'),
            },
            minDate: new Date(),
        };
    },

    computed: {
        getLicenseAmountOfSelectedClient() {
            if (this.fields.debitClientId != '') {
                return this.debitClients.find(client => {
                    return client.id == this.fields.debitClientId;
                })['license_amount'];
            }
        },

        filteredDebitClients() {
            return this.debitClients.filter(client => {
                return client.id != this.client.id;
            });
        },
    },
};
</script>
